



























import { Prop, Component, Vue } from "vue-property-decorator";
import { Staff } from "@/api/company-api";

@Component({
  props: {
    visible: {
      type: Boolean
    }
  }
})
export default class VInviteModal extends Vue {
  @Prop({ required: true }) staff!: Staff;
}
